import {ButtonBack, ButtonNext, CarouselContext} from "pure-react-carousel";
import {useContext, useEffect, useState} from "react";
import arrow from "../assets/images/arrow.svg";

function QuizSlider({setPanel, control, timer}) {
    const carouselContext = useContext(CarouselContext);
    const [currentSlide, setCurrentSlide] = useState(carouselContext.state.currentSlide);

    useEffect(() => {
        function onChange() {
            setCurrentSlide(carouselContext.state.currentSlide)
            if (timer) clearTimeout(timer)
        }
        carouselContext.subscribe(onChange);
        return () => carouselContext.unsubscribe(onChange);
    }, [carouselContext, timer]);

    return (
        <section className={"control-panel"}>
            <button className={"change-quiz"} onClick={() => setPanel("selector")}>
                <img src={arrow} alt={"arrow icon"}/><span>Change quiz</span>
            </button>
            <div className={"control-slides"} ref={control}>
                <ButtonBack className={"back"}><img src={arrow} alt={"arrow icon"}/></ButtonBack>
                <div><strong>{currentSlide + 1}</strong> of {carouselContext.state.totalSlides}</div>
                <ButtonNext className={"next"}><img src={arrow } alt={"arrow icon"}/></ButtonNext>
            </div>
        </section>
    )
}

export default QuizSlider
